module.exports = {"id":"183287","name":"Fabien Lemoine","rating":"72","photo":"./data/images/photos/4/183287.png","club":{"name":"FC Lorient","logo":"./data/images/clubs/FCLorient.png"},"positions":["MC","MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FabienLemoine0.json
// module id = 1338
// module chunks = 0